var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-navbar-nav",class:[
    `footer-navbar-nav--${_vm.view}`,
    _vm.isOpen ? 'footer-navbar-nav--open' : '',
  ]},[_c('header',{staticClass:"footer-navbar-nav__header",on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_c('h4',{staticClass:"footer-navbar-nav__title"},[_vm._t("title")],2)]),_c('div',{staticClass:"footer-navbar-nav__body"},[_c('ul',{staticClass:"footer-navbar-nav__list"},[_vm._t("default",null,{"itemClass":"footer-navbar-nav__item","linkClass":"footer-navbar-nav__link"})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }